<template>
   <div id="careerList" v-if="careerData">
      <div class="careerList-banner">
         <div class="banner-text">
            <p>助你成就职业未来</p>
            <p>每条路径精选搭配，跟着学事半功倍！</p>
         </div>
      </div>
      <div class="careerList-main">
         <ul class="careerList-item">
            <li v-for="(item,index) in careerData" :key="index">
               <a :href="'/career/'+ item.career_id" class="careerList-href">
                  <div class="careerItem-left">
                     <p class="title">{{ item.career_synopsis }}</p>
                     <p class="text">{{ item.career_intro }}</p>
                     <p class="stage">{{ item.career_item_count }}大阶段<i>·</i>{{ item.ablum_time[0] }}小时<i>·</i>{{ $teachFun(item.chapter_count) }}人在学</p>
                  </div>
                  <div class="careerItem-right">
                     <img :src="item.career_img" alt=""/>
                  </div>
               </a>
            </li>
         </ul>
         <p v-if="loadIcon" class="careerList-load"><span>加载中</span></p>
         <p v-if="scrollTips" class="careerList-more"><span>尽情期待更多职业路径</span></p>
      </div>

      <!-- vip体验卡到期弹窗 -->
      <VipCardPopup ref="vipCardPopup" />
   </div>
</template>
<script>
   import { careerLists as getCareerLists } from '@/api/career/';
   import VipCardPopup from '@/components/Vip/vipCard/index.vue'
   export default {
      name: "CareerList",
      components: {
         VipCardPopup,
      },
      
      data() {
         return {
            total: 0,
            count: 1,
            list: [],
            careerData: [],
            loadIcon: false,
            scrollTips: false,
         };
      },
      created() {

      },
      mounted() {
         this.getCareerLists();
         let timers;
         window.addEventListener('scroll', () => {
            // 获取滚动的距离
            let scrollTop = $(document).scrollTop();
            // 获取滚动的高度（获取整个html的高度）
            let scrollHeight = window.screen.availHeight;
            // 获取屏幕(浏览器)高度
            let clienHeight = $(window).height();
            // 滚动的距离 + 屏幕高度 - 内容高度 >= 0 表示滚动到底部了      (下拉加载判断条件)
            if ((scrollTop + clienHeight + 60) >= scrollHeight) {
               clearTimeout(timers);
               timers = setTimeout(() => {
                  if(this.total >= this.count){
                     this.loadIcon = true;
                     this.getCareerLists();
                  }else{
                     this.loadIcon = false;
                     this.scrollTips = true;
                  }
               }, 300);
            }
         });
      },
      methods: {
         async getCareerLists(){
            let data = {
               page: this.count,
            }
            const res = await getCareerLists(data)
            if (res.msg == "Success") {
               this.list = res.data.lists;
               this.total = res.data.page_count;
               this.careerData.push(...this.list);
               this.loadIcon = false;
               this.count++;
            }
         },
      }
   }
</script>

<style lang="scss" scoped>
   .careerList-banner{
      width: 100%;
      height: 520px;
      background: url("~@/assets/images/career/banner.png") no-repeat;
      background-size: cover;
      padding-top: 128px;
      box-sizing: border-box;
      .banner-text{
         width: 100%;
         text-align: center;
         p{
            color: #ffffff;
            font-weight: bold;
            letter-spacing: 2px;
            &:nth-child(1){
               line-height: 60px;
               font-size: 60px;
               position: relative;
               margin-bottom: 64px;
               &::before{
                  content: "";
                  width: 100px;
                  height: 4px;
                  background-color: #ff7b33;
                  border-radius: 2px;
                  position: absolute;
                  bottom: -34px;
                  left: 50%;
                  margin-left: -50px;
               }
            }
            &:nth-child(2){
               line-height: 24px;
               font-size: 24px;
            }
         }
      }
   }
   .careerList-main{
      width: 100%;
      padding: 0 33px 60px;
      box-sizing: border-box;
      .careerList-item{
         width: 100%;
         margin-top: -156px;
         li{
            width: 100%;
            background: #FFFFFF;
            box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.1000);
            border-radius: 15px;
            &:not(:last-child){
               margin-bottom: 40px;
            }
             .careerList-href{
                 width: 100%;
                 padding: 30px 20px 30px 30px;
                 display: flex;
                 justify-content: space-between;
                 align-items: center;
                 box-sizing: border-box;
                 .careerItem-left{
                    width: 310px;
                    position: relative;
                    &::after{
                       content: "";
                       width: 40px;
                       height: 4px;
                       background-color: #ff9500;
                       border-radius: 2px;
                       position: absolute;
                       top: 48px;
                       left: 0;
                    }
                     .title{
                         width: 100%;
                         height: 30px;
                         line-height: 30px;
                         font-size: 30px;
                         color: #404040;
                         font-weight: bold;
                         text-align: justify;
                         text-overflow: ellipsis;
                         white-space: nowrap;
                         overflow: hidden;
                     }
                     .text{
                         width: 100%;
                         height: 108px;
                         line-height: 36px;
                         font-size: 24px;
                         color: #666666;
                         text-align: justify;
                         display: -webkit-box;
                         -webkit-box-orient: vertical;
                         -webkit-line-clamp: 3;
                         overflow: hidden;
                         margin: 33px 0;
                     }
                     .stage{
                         width: 100%;
                         line-height: 20px;
                         font-size: 20px;
                         color: #9d9d9d;
                         white-space: nowrap;
                         i{
                             margin: 0 2px;
                         }
                     }
                 }
                 .careerItem-right{
                     width: 294px;
                     padding-bottom: 22px;
                     position: relative;
                     &::before{
                         content: "";
                         width: 268px;
                         height: 198px;
                         background: url("~@/assets/images/career/career_shading.png") no-repeat;
                         background-size: cover;
                         position: absolute;
                         left: 50%;
                         bottom: 0;
                         transform: translateX(-50%);
                     }
                     img{
                         width: 100%;
                         height: 202px;
                         border-radius: 10px;
                         position: relative;
                         display: block;
                         z-index: 8;
                     }
                 }
             }
         }
      }
      .careerList-load{
         width: 100%;
         height: 32px;
         text-align: center;
         margin-top: 60px;
         span{
            height: 100%;
            line-height: 32px;
            font-size: 24px;
            color: #9d9d9d;
            padding-left: 46px;
            position: relative;
            display: inline-block;
            vertical-align: top;
            &::before{
               content: "";
               width: 32px;
               height: 32px;
               background: url("~@/assets/images/career/loading.gif") no-repeat;
               background-size: cover;
               position: absolute;
               top: 0;
               left: 0;
            }
         }
      }
      .careerList-more{
         width: 100%;
         height: 22px;
         text-align: center;
         margin-top: 60px;
         span{
            height: 100%;
            line-height: 22px;
            font-size: 22px;
            color: #9d9d9d;
            display: inline-block;
            vertical-align: top;
            position: relative;
            &::before,
            &::after{
               content: "";
               width: 150px;
               border-top: 1px solid #cccccc;
               position: absolute;
               top: 50%;
               transform: translateY(-50%);
            }
            &::before{
               left: -180px;
            }
            &::after{
               right: -180px;
            }
         }
      }
   }
</style>
